import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import { PlayAudioButton } from 'components/flink-play';
import classes from './Item.module.scss';
import { s3bucketPublicURL, uploadsURL, activitiesKey } from 'config';

const Item = ({ data, currentActivity, contentFolder, activity, solutionLocale }) => {
  if (process.env.NODE_ENV !== 'production' && data == null) {
    console.warn('[Item] data is undefined; rendering noop', {
      activityId: activity?._id,
      contentFolder,
      href: typeof window !== 'undefined' ? window.location.href : ''
    });
  }

  const { text, image, audio, audioPath } = data || {};

  const isEditor =
    typeof window !== 'undefined' && window.location.href.indexOf('edit-activities') !== -1;

  const locale = activity?.monolingual
    ? ''
    : (isEditor && activity?.currentLanguageVersion?.locale)
      ? activity.currentLanguageVersion.locale
      : (solutionLocale?.code || '');

  const requestedVersionType = (!locale || locale === 'en') ? '' : `immersion_${locale}`;
  const hasLocalizedGameData = requestedVersionType
    ? !!currentActivity?.data?.languageVersionData?.[requestedVersionType]
    : false;
  const versionType = hasLocalizedGameData ? requestedVersionType : '';

  const contentPath =
    audioPath ||
    (versionType
      ? `${uploadsURL}/${activitiesKey}/${activity?._id}/languageVersionData/${versionType}/`
      : `${s3bucketPublicURL}/${contentFolder}/gamedata/`);

  if (process.env.NODE_ENV !== 'production') {
    console.log('[FindTheOne][Item][assetResolve]', {
      locale,
      requestedVersionType,
      effectiveVersionType: versionType,
      hasLocalizedGameData,
      contentPath,
      image: image || '',
      audio: audio || '',
    });
  }

  return (
    <div className={classes.itemMixed}>
      {audio && (
        <PlayAudioButton
          url={(audioPath || contentPath) + audio}
          className={classnames({
            [classes.playAudioBtn]: !text && !image,
            [classes.playAudioBtnSmall]: text || image
          })}
        />
      )}

      {text ? (
        <span>{text}</span>
      ) : image ? (
        <img className={classes.itemImg} src={contentPath + image} alt="" />
      ) : null}
    </div>
  );
};

Item.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string,
    image: PropTypes.string,
    audio: PropTypes.string,
    audioPath: PropTypes.string
  }),
  currentActivity: PropTypes.shape({
    data: PropTypes.object,
    activity: PropTypes.object,
  }),
  contentFolder: PropTypes.string.isRequired,
  activity: PropTypes.shape({
    _id: PropTypes.string,
    monolingual: PropTypes.bool,
    currentLanguageVersion: PropTypes.shape({
      locale: PropTypes.string
    })
  }),
  solutionLocale: PropTypes.shape({
    code: PropTypes.string
  })
};

const mapStateToProps = ({ game, flinkPlay: { solutionLocale, activityLocale } }) => ({
  currentActivity: game?.currentActivity,
  contentFolder: game?.currentActivity?.activity?.contentFolder,
  activity: game?.currentActivity?.activity,
  solutionLocale: activityLocale || solutionLocale
});

export default connect(mapStateToProps)(Item);
